"use strict";

var fuzzySearch = function fuzzySearch(string, query) {
  var targetString = string.toLowerCase();
  var targetQuery = query.toLowerCase();
  var previousIndex = -1;
  for (var i = 0; i < targetQuery.length; i++) {
    var currentLetter = targetQuery[i];
    // Check if the letter follows after the previous match
    var letterIndex = targetString.indexOf(currentLetter, previousIndex + 1);
    if (letterIndex === -1) {
      return false;
    }
    previousIndex = letterIndex;
  }
  return true;
};
module.exports = fuzzySearch;